import React, { useState, useEffect } from "react";
import { TVehicle } from "models/inventory/interfaces/vehicle.interface";
import { Typography } from "design_system/src";
import styles from "./DetailTags.module.scss";

interface DetailTagsProps {
  vehicle?: TVehicle;
}

const DetailTags = ({vehicle}: DetailTagsProps) => {
  const [tags, setTags] = useState<String[]>([]);

  useEffect(() => {
    if (vehicle) setTags([
      vehicle.year.toString(),
      `${vehicle.cylindersCapacity} CC`,
      `${vehicle.mileage} Km`
    ]);

  }, [vehicle]);

  return (
    <div className="display_flex flex_gap_xxs flex_wrap">
      {tags.map((tag, index) => {
        return (
          <Typography
            scale="xsmall"
            weight="600"
            className={styles.tag}
            key={`vehicle-detail-${index}`}
          >
            {tag}
          </Typography>
        );
      })}

      {vehicle?.maintenanceDays === 0 && <Typography
        scale="xsmall"
        weight="600"
        className={`${styles.tag} ${styles["tag--dark"]}`}
      >
        Entrega inmediata
      </Typography>}
    </div>
  );
};

export default DetailTags;
